import React, { useState } from "react";
import { API_URL } from "../../../api";
import Cookies from "universal-cookie";
import "./admin.css";

const Admin = ({ data }) => {
	const [json_users, setJsonUsers] = useState([]);
	const [value, setValue] = useState("");
	const [setData] = useState();

	const verifyCode = () => {
		const cookies = new Cookies();
		const sessionToken = cookies.get("sessionToken");

		fetch(
			`${API_URL}/api/AdminData?token=${sessionToken}&password=${value}`
		)
			.then((response) => response.json())
			.then((data) => {
				if (data.status) {
					const keys = Object.getOwnPropertyNames(
						data.data[data.data.length - 1]
					);
					setJsonUsers(keys);
					setData(data.data);
				} else {
					alert("Wrong password hehe");
				}
			})
			.catch((error) => {
				alert("Wrong password hehe");
			});
	};

	return (
		<div className="admin">
			<div className="verify">
				<input
					id="code"
					type="text"
					placeholder="Enter verification code"
					value={value}
					onChange={(e) => {
						setValue(e.target.value);
					}}
				/>
				<button className="btn" onClick={verifyCode}>
					Verify
				</button>
			</div>
			<div className="data">
				<h1>Poročilo za današnji teden ({json_users.length} 🕴):</h1>
				{json_users.map((user) => (
					<h2>{user}</h2>
				))}
			</div>
		</div>
	);
};

export default Admin;
